// components/MultiPlatformPixelScript/googleUserData.ts — Enhanced Conversions user_data
// Satu setter dipakai foreground (event) & background (hash telat) — dulunya duplikat.
export function setGoogleUserData(g: any, h: Record<string, string>, logPrefix: string): void {
    try {
        const ud: any = {};
        if (h.email) ud.email = h.email;
        if (h.phone_number) ud.phone_number = h.phone_number;
        if (h.fn || h.ln || h.ct || h.st || h.zip || h.country) {
            ud.address = {};
            if (h.fn) ud.address.first_name = h.fn;
            if (h.ln) ud.address.last_name = h.ln;
            if (h.ct) ud.address.city = h.ct;
            if (h.st) ud.address.region = h.st;
            if (h.zip) ud.address.postal_code = h.zip;
            if (h.country) ud.address.country = h.country;
        }
        if (Object.keys(ud).length) { g('set', 'user_data', ud); console.log(`[${logPrefix} Google] user_data set`, Object.keys(ud)); }
    } catch { /* */ }
}
